<template>
  <div class="modal" :class="{'is-active': opened}">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Update inbound shipment</p>
        <button class="delete" @click="close"></button>
      </header>
      <section class="modal-card-body">

        <div class="field">
          <label class="label">Status</label>
          <div class="control">
            <div class="select">
              <select v-model="newShipmentStatus">
                <option>toBeShipped</option>
                <option>inTransit</option>
                <option disabled>partiallyReceived</option>
                <option disabled>received</option>
                <option disabled>closed</option>
              </select>
            </div>
          </div>
        </div>

        <div class="field">
          <label class="label">Expected Shipping Date</label>
          <div class="control">
            <input class="input" v-model="newExpectedShippingDate" :class="{'is-danger': !expectedShippingDateValid}" type="text" placeholder="YYYY-MM-DD">
          </div>
        </div>

        <div class="field">
          <label class="label">Actual Shipping Date</label>
          <div class="control">
            <input class="input" v-model="newActualShippingDate" :class="{'is-danger': !actualShippingDateValid}" type="text" placeholder="YYYY-MM-DD">
          </div>
        </div>

        <div class="field">
          <label class="label">Expected Delivery Date</label>
          <div class="control">
            <input class="input" v-model="newExpectedDeliveryDate" :class="{'is-danger': !expectedDeliveryDateValid}" type="text" placeholder="YYYY-MM-DD">
          </div>
        </div>

        <div class="field">
          <label class="label">Actual Delivery Date</label>
          <div class="control">
            <input class="input" v-model="newActualDeliveryDate" :class="{'is-danger': !actualDeliveryDateValid}" type="text" placeholder="YYYY-MM-DD">
          </div>
        </div>

        <div v-if="error" class="notification is-danger is-light">
          <button class="delete" @click="error=''"></button>
          {{error}}
        </div>
      </section>
      <footer class="modal-card-foot">
        <a class="button is-link" :class="{'is-loading': waiting}" :disabled="!changed || !valid" @click="updateInbound">Update</a>
        <a class="button" @click="close">Cancel</a>
      </footer>
    </div>
  </div>
</template>
  
<script>

export default {
  name: 'inbound-modal',
  props: ['opened', 'inbound'],
  data () {
    return {
      error: '',
      waiting: false,
      newShipmentStatus: '',
      newExpectedShippingDate: '',
      newActualShippingDate: '',
      newExpectedDeliveryDate: '',
      newActualDeliveryDate: '',
    }
  },
  computed: {
    server () {
      return this.$store.state.config.server
    },
    expectedShippingDateValid () {
      return !this.newExpectedShippingDate || this.validDate(this.newExpectedShippingDate)
    },
    actualShippingDateValid () {
      return !this.newActualShippingDate || this.validDate(this.newActualShippingDate)
    },
    expectedDeliveryDateValid () {
      return !this.newExpectedDeliveryDate || this.validDate(this.newExpectedDeliveryDate)
    },
    actualDeliveryDateValid () {
      return !this.newActualDeliveryDate || this.validDate(this.newActualDeliveryDate)
    },
    valid () {
      return this.newShipmentStatus && this.expectedShippingDateValid && this.actualShippingDateValid && this.expectedDeliveryDateValid && this.actualDeliveryDateValid
    },
    changed () {
      if (!this.inbound) {
        return false
      }
      return this.newShipmentStatus != this.inbound.shipmentStatus
        || this.newExpectedShippingDate != this.inbound.expectedShippingDate
        || this.newActualShippingDate != this.inbound.actualShippingDate
        || this.newExpectedDeliveryDate != this.inbound.expectedDeliveryDate
        || this.newActualDeliveryDate != this.inbound.actualDeliveryDate
    },
  },
  watch: {
    opened: function (val) {
      if (val && this.inbound) {
        this.newShipmentStatus = this.inbound.shipmentStatus
        this.newExpectedShippingDate = this.inbound.expectedShippingDate
        this.newActualShippingDate = this.inbound.actualShippingDate
        this.newExpectedDeliveryDate = this.inbound.expectedDeliveryDate
        this.newActualDeliveryDate = this.inbound.actualDeliveryDate
      }
    }
  },
  methods: {
    close () {
      this.$emit('closeInboundModal', false)
    },
    validDate (s) {
      return /^\d{4}-\d{2}-\d{2}$/.test(s)
    },
    updateInbound () {
      if (!this.changed || !this.valid) {
        return
      }
      var message = {
        id: this.inbound.id,
        shipmentStatus: this.newShipmentStatus,
        expectedShippingDate: this.newExpectedShippingDate,
        actualShippingDate: this.newActualShippingDate,
        expectedDeliveryDate: this.newExpectedDeliveryDate,
        actualDeliveryDate: this.newActualDeliveryDate,
      }
      this.waiting = true
      this.$http.post(this.server + '/myapp/update-submitted-inbound/', message).then(resp => {
        this.waiting = false
        this.$emit('closeInboundModal', true)
      }, err => {
        this.waiting = false
        this.error = err.body
      })
    },
  },
}
</script>

<style scoped>

</style>